import appModeController from '@/scripts/appModeController'
import { events } from '@/scripts/config/events'
import buttons from '@/scripts/ui/buttons'

const EVENT_GENERAL_CUSTOM = 'general_custom_event'

export const ACTION_ACTIVITY_HOVER = 'activity_hover'
export const ACTION_ACTIVITY_OPEN = 'activity_open'
export const ACTION_ACTIVITY_VIEW = 'activity_view'
export const ACTION_ACTIVITY_START = 'activity_start'
export const ACTION_ACTIVITY_CLOSE = 'activity_close'
export const ACTION_SECRET_HOVER = 'secret_hover'
export const ACTION_SECRET_OPEN = 'secret_open'
export const ACTION_STORE_REDIRECT_VIEW = 'app_store_redirect_view'
export const ACTION_STORE_REDIRECT_CLICK = 'app_store_redirect_click'
export const ACTION_LINK_CLICK = 'link_click'
const ACTION_ACTIVITY_NUMBERS_SHOW = 'activity_numbers_show'
const ACTION_ACTIVITY_NUMBERS_HIDE = 'activity_numbers_hide'
const ACTION_MUSIC_SWITCH_ON = 'music_switch_on'
const ACTION_MUSIC_SWITCH_OFF = 'music_switch_off'

const LABEL_DECKO = 'decko'

const sendCustomEvent = (action: string, label: string | number = '', isInteraction: boolean = true) => {
  if (window.DP && window.DP.analytics && window.dpAnalytics) {
    try {
      const DP = window.DP as {
        analytics?: {
          EventBuilder: new () => {
            setEventName: (name: string) => {
              setCustom: (
                action: string,
                label: string | number,
                mode: string,
              ) => {
                setInteraction: (interaction: boolean) => unknown
              }
            }
          }
        }
      }
      const dpAnalytics = window.dpAnalytics as {
        trackEvent?: (event: unknown) => void
      }
      if (DP.analytics && dpAnalytics.trackEvent) {
        const eventBuilder = new DP.analytics.EventBuilder()
          .setEventName(EVENT_GENERAL_CUSTOM)
          .setCustom(action, label, appModeController.getCurrentMode())
          .setInteraction(isInteraction)
        dpAnalytics.trackEvent(eventBuilder)
      }
    } catch (exception) {
      console.error(exception)
    }
  }
}

function init(): void {
  initAutoTracking()
  trackButtons()
}

/**
 * Scans the DOM for elements with data-track-id and automatically binds sendCustomEvent() appropriately.
 * Also binds analytics on music and help buttons
 */
function initAutoTracking() {
  // Auto-tracking setup for elements with data-track-id
  const TRACKING_MAP: Record<string, [string, string?]> = {
    // Keys match data-track-id attribute values
    [LABEL_DECKO]: [ACTION_LINK_CLICK, LABEL_DECKO],
  }

  const trackedElements = document.querySelectorAll<HTMLElement>('[data-track-id]')
  trackedElements.forEach((el) => {
    const id = el.dataset.trackId
    if (!id || !(id in TRACKING_MAP)) return
    const [action, label] = TRACKING_MAP[id]
    el.addEventListener('click', () => sendCustomEvent(action, label ?? ''))
  })
}

function trackButtons() {
  buttons.on(events.MUSIC_BUTTON_CLICK, (active: boolean) => {
    sendCustomEvent(active ? ACTION_MUSIC_SWITCH_ON : ACTION_MUSIC_SWITCH_OFF)
  })
  buttons.on(events.HELP_BUTTON_CLICK, (active: boolean) => {
    sendCustomEvent(active ? ACTION_ACTIVITY_NUMBERS_SHOW : ACTION_ACTIVITY_NUMBERS_HIDE)
  })
}

export default { init, sendCustomEvent }
